<div class="defect-details-container">
  <div class="hs-header">
    <span class="hs-title">{{metricDisplayName}}</span>
  </div>
  <div class="chart-container">
    <app-pie-chart
      [chartType]="'doughnut'"
      [data]="getChartData()"
      [backgroundColors]="['#FC404A', '#E8E8E9']"
      [meta]="getChartMeta()"
      [showValueOnly]="false">
    </app-pie-chart>
    <div class="chart-center-text">
      <div class="total-count">{{ data?.total_defects || 0 }}</div>
      <div class="total-label">Total Defects<br>Reported</div>
    </div>
  </div>

  <div class="defect-stats">
    <div class="stat-card open-defect">
      <div class="d-flex justify-content-between">
        <div class="stat-number">{{ data?.open_defects || 0 }}</div>
        <div class="stat-percentage">{{ getPercentage('open') }}%</div>
      </div>
      <div class="stat-label">Open Defects</div>
    </div>
    <div class="stat-card closed-defect">
      <div class="d-flex justify-content-between">
        <div class="stat-number">{{ data?.closed_defects || 0 }}</div>
        <div class="stat-percentage">{{ getPercentage('closed') }}%</div>
      </div>
      <div class="stat-label">Closed Defects</div>
    </div>
  </div>

  <div class="info-box">
    <span class="bullet">•</span>
    <span class="info-text">
      <strong>Prioritization of defects:</strong> Helps in determining the severity & urgency of fixing a defect based on its potential impact.
    </span>
  </div>
</div>


<!-- 
<div class="v-center align-items-center w-100 h-100 d-flex flex-column gap-2">

    <div
      *ngFor="let item of defectCards"
      class="d-flex flex-row align-items-center card-defect w-100"
      [ngClass]="item.cssClass"
    >
      <img
        [src]="'assets/images/virtusa-icons/' + item.imageUrl"
        alt="defect"
      />
      <div class="d-flex flex-column mx-3 gap-2">
        <span>{{ item.description }}</span>
        <span class="count">{{ item.value() }}</span>
      </div>
    </div>
  
    <div class="card-defect w-100 ps-0">
      <span>{{ meta.description }}</span>
    </div>
  
  </div>
  
   -->